import { signMessage, waitForTransaction } from '@wagmi/core';
import { chain } from '$lib/wallet/store';

import {
	fetchAllCompetitions,
	fetchTradingSeasonStats,
	fetchUserActivity,
	fetchUserMysteryOrbs,
	fetchUserPolyPoints,
	fetchUserTradingSeasonStats,
	handleClaimLevelNftApiCall,
	handleClaimOrbApiCall
} from '$lib/apis/rewards';
import { fetchTradingSeasonConfig } from '$lib/apis/rewards';
import {
	allCompetitions,
	loadingAllCompetitions,
	// estimatedAccruedRewards,
	// estimatedTradeReward,
	// estimatedTradeRewardClosePosition,
	// loadingRewards,
	loadingSelectedSeason,
	loadingUserActivity,
	loadingUserMysteryOrbs,
	loadingUserPolyPoints,
	// loadingTradeReward,
	// loadingTradeRewardClosePosition,
	loadingUserSeasonStats,
	seasons,
	userActivity,
	userMysteryOrbs,
	userPolyPoints,
	userSeasonStats
} from '$lib/tradingSeason/store';
import type {
	MysteryOrbs,
	PolyPoints,
	Season,
	SeasonIdentifiers,
	SeasonStats,
	UserActivity,
	UserSeasonData
} from '$lib/types/tradingRewards';
import { get } from 'svelte/store';
import mintLevelNft from '$lib/web3/actions/mintLevelNft';
import type { CompetitionConfig } from '$lib/types/leaderboard';
import {
	addErrorNotification,
	addTransactionNotification
} from '$lib/notifications/notificationManager';

export async function getEstimatedAccruedRewards(address: string) {
	// try {
	// 	if (!get(estimatedAccruedRewards)) loadingRewards.set(true);
	// 	const data: EstimatedAccruedRewards = await fetchEstimatedAccruedRewards(address);
	// 	estimatedAccruedRewards.set(data);
	// 	loadingRewards.set(false);
	// } catch (e) {
	// 	loadingRewards.set(false);
	// }
}

export async function getEstimatedTradingReward(fee: string) {
	// try {
	// 	loadingTradeReward.set(true);
	// 	const data: EstimatedTradingReward = await fetchEstimatedTradingReward(fee);
	// 	estimatedTradeReward.set(data);
	// 	loadingTradeReward.set(false);
	// } catch (e) {
	// 	loadingTradeReward.set(false);
	// }
}

export async function getEstimatedTradingRewardClosePosition(fee: string) {
	// try {
	// 	loadingTradeRewardClosePosition.set(true);
	// 	const data: EstimatedTradingReward = await fetchEstimatedTradingReward(fee);
	// 	estimatedTradeRewardClosePosition.set(data);
	// 	loadingTradeRewardClosePosition.set(false);
	// } catch (e) {
	// 	loadingTradeRewardClosePosition.set(false);
	// }
}

async function setNumberOfAccountsPerLevel(seasonIdentifier: SeasonIdentifiers) {
	try {
		let data: SeasonStats = (await fetchTradingSeasonStats(seasonIdentifier)) as SeasonStats;
		if (data) {
			const existingConfig = get(seasons);
			if (existingConfig && existingConfig.hasOwnProperty(seasonIdentifier)) {
				const season = existingConfig[seasonIdentifier];

				data.accountsPerLevel.forEach((l) => {
					const level = season.levels.find((level) => level.level === l.level);
					if (level) {
						level.numberOfAccounts = l.numAccounts;
					}
				});
				seasons.set(existingConfig);
			}
		}
	} catch (e) {
		console.log(e);
	}
}

export async function getTradingSeasonConfig(seasonIdentifier: SeasonIdentifiers) {
	try {
		let existingConfig = get(seasons);
		if (existingConfig && existingConfig.hasOwnProperty(seasonIdentifier)) {
			loadingSelectedSeason.set(true);
		}
		const data: Season = (await fetchTradingSeasonConfig(seasonIdentifier)) as Season;

		if (data.levels && data.levels.length > 0) {
			data.levels = data.levels.filter((l) => l.level > 0);
		}

		if (!existingConfig) {
			existingConfig = {};
		}

		existingConfig[seasonIdentifier] = data;
		seasons.set(existingConfig);
		setNumberOfAccountsPerLevel(seasonIdentifier);
		return data;
	} catch (e) {
		console.log(e);
	} finally {
		loadingSelectedSeason.set(false);
	}
}

export async function getUserTradingSeasonStats(
	seasonIdentifier: SeasonIdentifiers,
	address: string
) {
	try {
		loadingUserSeasonStats.set(true);
		const data = (await fetchUserTradingSeasonStats(seasonIdentifier, address)) as UserSeasonData;
		userSeasonStats.set(data);
	} catch (e) {
		console.log(e);
	} finally {
		loadingUserSeasonStats.set(false);
	}
}

export async function getUserMysteryOrbs(address: string) {
	try {
		loadingUserMysteryOrbs.set(true);
		const data = (await fetchUserMysteryOrbs(address)) as MysteryOrbs[];
		userMysteryOrbs.set(data);
	} catch (e) {
		console.log(e);
	} finally {
		loadingUserMysteryOrbs.set(false);
	}
}

export async function claimOrb(orbId: string, address: string) {
	try {
		const message = 'Claim Mystery Orb';
		const signature = await signMessage({
			message
		});
		await handleClaimOrbApiCall(orbId, address, signature);
		await getUserMysteryOrbs(address);
		await getUserPolyPoints(address);
	} catch (e: any) {
		addErrorNotification('Something went wrong!', "Couldn't claim Orb", e.message);
		throw new Error('Orb claiming failed.');
	}
}

export async function claimLevelNft(
	address: string,
	level: number,
	seasonIdentifier: SeasonIdentifiers
) {
	try {
		const response = await handleClaimLevelNftApiCall(address, level);
		if (!response) {
			throw new Error('Something went wrong');
		}

		const txn = await mintLevelNft(response!.account, response!.nftId, response!.data);
		addTransactionNotification(
			'NFT Minted',
			`You have successfully claimed the level ${level} NFT`,
			txn
		);

		await waitForTransaction({
			chainId: get(chain)?.id,
			hash: txn.hash
		});

		setTimeout(() => {
			getUserTradingSeasonStats(seasonIdentifier, address);
		}, 8000);
	} catch (e: any) {
		addErrorNotification('Something went wrong!', "Couldn't claim NFT", e.message);
		throw new Error(e.message);
	}
}

export async function getUserPolyPoints(address: string) {
	try {
		loadingUserPolyPoints.set(true);

		const data = (await fetchUserPolyPoints(address)) as PolyPoints;
		userPolyPoints.set(data);
	} catch (err) {
		console.log(err);
	} finally {
		loadingUserPolyPoints.set(false);
	}
}

export async function getAllCompetitions() {
	try {
		loadingAllCompetitions.set(true);

		const data = (await fetchAllCompetitions()) as CompetitionConfig[];
		allCompetitions.set(data);
	} catch (err) {
		console.log(err);
	} finally {
		loadingAllCompetitions.set(false);
	}
}

export async function getUserActivity(address: string) {
	try {
		loadingUserActivity.set(true);

		const data = (await fetchUserActivity(address)) as UserActivity[];
		if (data) userActivity.set(data);
	} catch (err) {
		console.log(err);
	} finally {
		loadingUserActivity.set(false);
	}
}
